<script>
export default {
  name: 'Vk',
  layout: 'frame',
}
</script>

<template>
  <h1>ВК49865</h1>
</template>

<style scoped lang="less">

</style>
